import React from "react";

const EmptyState = ({}) => (
  <svg
    width="117"
    height="120"
    viewBox="0 0 117 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M105.488 69.6703H93.2113V56.7572C93.2113 54.7452 91.5858 53.1197 89.5738 53.1197H53.7672L40.4335 40.3657C40.2638 40.2069 40.0407 40.1176 39.8083 40.1156H10.9129C8.9009 40.1156 7.27539 41.7411 7.27539 43.7531V111.047C7.27539 113.059 8.9009 114.684 10.9129 114.684H90.2559C91.7336 114.684 93.0749 113.786 93.6319 112.411L108.864 74.6718C109.034 74.2399 109.125 73.7738 109.125 73.3078C109.125 71.2958 107.5 69.6703 105.488 69.6703ZM87.6755 106.5H18.0742L29.8165 77.4H99.4292L87.6755 106.5Z"
      fill="#E2E8F0"
    />
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 29.75C28 25.4698 32.0294 22 37 22H79.7301C80.9837 22 82 23.0163 82 24.2699V37.5C82 39.5667 82 40.9247 82 42.9801V76.25C82 80.5302 77.9706 84 73 84H37C32.0294 84 28 80.5302 28 76.25V29.75ZM37 53C37 50.8599 39.0147 49.125 41.5 49.125H68.5C70.9853 49.125 73 50.8599 73 53C73 55.1401 70.9853 56.875 68.5 56.875H41.5C39.0147 56.875 37 55.1401 37 53ZM41.5 64.625C39.0147 64.625 37 66.3599 37 68.5C37 70.6401 39.0147 72.375 41.5 72.375H68.5C70.9853 72.375 73 70.6401 73 68.5C73 66.3599 70.9853 64.625 68.5 64.625H41.5Z"
        fill="#CFD8E3"
      />
      <path
        d="M63.125 15.2501C63.125 12.9949 64.9532 11.1667 67.2083 11.1667H87.625C89.8802 11.1667 91.7083 12.9949 91.7083 15.2501V27.5001C91.7083 29.7552 89.8802 31.5834 87.625 31.5834H79.4583L72.4876 38.5541L71.2917 39.7501V31.5834H67.2083C64.9532 31.5834 63.125 29.7552 63.125 27.5001V15.2501Z"
        fill="#97A6BA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.0048 17.0051C74.2782 16.7317 74.7214 16.7317 74.9948 17.0051L77.9998 20.0101L81.0048 17.0051C81.2782 16.7317 81.7214 16.7317 81.9948 17.0051C82.2681 17.2784 82.2681 17.7217 81.9948 17.995L78.9898 21L81.9948 24.0051C82.2681 24.2784 82.2681 24.7217 81.9948 24.995C81.7214 25.2684 81.2782 25.2684 81.0048 24.995L77.9998 21.99L74.9948 24.995C74.7214 25.2684 74.2782 25.2684 74.0048 24.995C73.7315 24.7217 73.7315 24.2784 74.0048 24.0051L77.0099 21L74.0048 17.995C73.7315 17.7217 73.7315 17.2784 74.0048 17.0051Z"
        fill="#E2E8F0"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="90"
          height="67.2"
          fill="white"
          transform="translate(10.2002 3)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default EmptyState;
